export default function formatServiceTime(serviceTime) {
  const foramtHour = Math.floor(serviceTime / 60);
  const foramtMinute = serviceTime % 60;

  const foramtHourText = foramtHour === 0
    ? ''
    : `${foramtHour}小時`;

  const foramtMinuteText = foramtMinute === 0
    ? ''
    : `${foramtMinute}分鐘`;

  return `${foramtHourText}${foramtMinuteText}`
}
